import React from 'react';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
    const { t } = useTranslation();

    return (
        <div className="max-w-4xl mx-auto space-y-8">
            {/* Hero Section */}
            <div className="text-center space-y-4">
                <h1 className="text-4xl font-bold text-gray-900">
                    <span className="bg-gradient-to-r from-green-600 to-green-800 bg-clip-text text-transparent">
                        {t('privacy.title', 'Privacy Policy')}
                    </span>
                </h1>
                <p className="text-lg text-gray-600">
                    {t('privacy.subtitle', 'Last updated: March 2024')}
                </p>
            </div>

            {/* Privacy Policy Content */}
            <div className="bg-white rounded-lg shadow-sm p-8 border border-gray-100 space-y-8">
                <section>
                    <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                        {t('privacy.sections.introduction.title', 'Introduction')}
                    </h2>
                    <p className="text-gray-600 leading-relaxed">
                        {t('privacy.sections.introduction.content',
                            'At MuslimTree, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.')}
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                        {t('privacy.sections.dataCollection.title', 'Information We Collect')}
                    </h2>
                    <div className="space-y-4">
                        <p className="text-gray-600 leading-relaxed">
                            {t('privacy.sections.dataCollection.content',
                                'We collect information that you provide directly to us, including but not limited to:')}
                        </p>
                        <ul className="list-disc list-inside space-y-2 text-gray-600">
                            <li>{t('privacy.sections.dataCollection.items.name', 'Name and contact information')}</li>
                            <li>{t('privacy.sections.dataCollection.items.email', 'Email address')}</li>
                            <li>{t('privacy.sections.dataCollection.items.usage', 'Usage data and preferences')}</li>
                        </ul>
                    </div>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                        {t('privacy.sections.dataUse.title', 'How We Use Your Information')}
                    </h2>
                    <div className="space-y-4">
                        <p className="text-gray-600 leading-relaxed">
                            {t('privacy.sections.dataUse.content',
                                'We use the information we collect to:')}
                        </p>
                        <ul className="list-disc list-inside space-y-2 text-gray-600">
                            <li>{t('privacy.sections.dataUse.items.service', 'Provide and maintain our services')}</li>
                            <li>{t('privacy.sections.dataUse.items.improve', 'Improve and personalize your experience')}</li>
                            <li>{t('privacy.sections.dataUse.items.communication', 'Communicate with you about our services')}</li>
                        </ul>
                    </div>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                        {t('privacy.sections.dataProtection.title', 'Data Protection')}
                    </h2>
                    <p className="text-gray-600 leading-relaxed">
                        {t('privacy.sections.dataProtection.content',
                            'We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.')}
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                        {t('privacy.sections.cookies.title', 'Cookies and Tracking')}
                    </h2>
                    <p className="text-gray-600 leading-relaxed">
                        {t('privacy.sections.cookies.content',
                            'We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.')}
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                        {t('privacy.sections.contact.title', 'Contact Us')}
                    </h2>
                    <p className="text-gray-600 leading-relaxed">
                        {t('privacy.sections.contact.content',
                            'If you have any questions about this Privacy Policy, please contact us at:')}
                    </p>
                    <a
                        href="mailto:privacy@muslimtree.org"
                        className="text-green-600 hover:text-green-700 transition-colors duration-200"
                    >
                        privacy@muslimtree.org
                    </a>
                </section>
            </div>
        </div>
    );
};

export default Privacy; 